import { get, getOr } from 'lodash/fp';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { fetchBlob } from '../../services/fbm-api/api-request';
import { formatDateRange } from '../dates';
import triggerBlobDownload from '../triggerBlobDownload';

export default async (type, searchQuery) => {
  const requestTime = get('requestTime', searchQuery);
  const qs = requestTime
    ? { ...searchQuery, requestTime: formatDateRange(requestTime) }
    : searchQuery;
  try {
    const blob = await fetchBlob(`reservations/exports/${type}`, { qs });
    const dateTime = moment().format('MM-DD-YYYY');
    const filename = `${type}-reservations-${dateTime}.csv`;
    triggerBlobDownload(blob, filename);
  } catch (err) {
    toastr.error('Error', getOr('Server error', 'message', err));
  }
};
